exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "form {\n  margin: 0 auto;\n  max-width: 600px;\n}\n\n.form-control {\n  margin-bottom: 1em;\n}\n\n.btn {\n  margin-bottom: 1em;\n  padding: 12px 18px;\n  font-size: 16px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/passwordreset/passwordreset.component.css
// module id = 849
// module chunks = 1